import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const savedY = sessionStorage.getItem("formScrollY")
    if (savedY) {
      sessionStorage.removeItem("formScrollY")
      const y = parseInt(savedY, 10)
      // Turbo scrolls to top after connect, so we need to restore after it finishes
      document.addEventListener("turbo:load", () => window.scrollTo(0, y), { once: true })
      // Fallback for non-Turbo navigations
      requestAnimationFrame(() => requestAnimationFrame(() => window.scrollTo(0, y)))
    }
  }

  submit() {
    sessionStorage.setItem("formScrollY", window.scrollY.toString())

    this.element.querySelectorAll('button[type="submit"], input[type="submit"]').forEach((btn) => {
      btn.setAttribute("data-submitting", "")
      btn.disabled = true
      const originalText = btn.dataset.originalText || btn.textContent
      btn.dataset.originalText = originalText
      btn.innerHTML = `<span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>${originalText}`
    })
  }
}
